module.exports = __webpack_public_path__ + "img/cbbank.c00709d1.png";